import isSupportNativeDataStorage from '../isSupportNativeDataStorage';

/** 客户端缓存-快捷绑定回执订单数据key */
export const NS_QUICK_BOUND_ORDER_DATA = 'finance_quickBoundOrderData';

/** 一键绑卡-进入通联页面的方式：是否可以使用新开Webview */
export const CAN_USE_NEW_WEBVIEW_FOR_JUMP = isSupportNativeDataStorage();
